import { ContentRecommendation } from '@/components/content/ContentRecommendation';

const EMS_NAME = 'DPV2_Global_Styles';

const NullElement = () => null;

export const GlobalStylesContent = () => (
	<ContentRecommendation
		id={EMS_NAME}
		withoutFrame
		properties={{
			emsName: EMS_NAME,
		}}
		loadingElement={<NullElement />}
	/>
);
